// extracted by mini-css-extract-plugin
export default {"selected":"DiagramRectangle_selected__xz-2m","edit-button":"DiagramRectangle_edit-button__egD6R"};